<template>
  <div >
   <!-- <van-nav-bar
      :title="cpinfo.name"
      left-text="返回"
      right-text="咨询"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      style="background-color:brown;"
    /> -->
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in cpinfo.mainpic" :key="index">
        <img :src="image" style="width:100%;"/>
      </van-swipe-item>
    </van-swipe>
    <div>
    <h3 style="width: 90%;color:#303133;margin-left: 20px;size:22px;">{{cpinfo.name}}</h3>

    <div v-once v-html="escape2Html(cpinfo.desc)" style="width: 96%;margin: 0 auto;"></div>

    <van-goods-action>





       <van-goods-action-icon icon="revoke" text="返回" @click="onClickLeft" />
       <!-- <van-goods-action-button type="warning" text="返回上一级" @click="onClickLeft" /> -->
      <van-goods-action-button type="danger" text="点击咨询" @click="onClickButton" />
    </van-goods-action>
    </div>
  </div>
</template>

<script>
  import * as Api from './api.js'
import jsonData from '../../../static/cp.json';

  export default {
    name: 'cplist',
    components:{},
    data () {
      return {
        cpinfo:{},
        index:"",
      }
    },
    created() {
      console.log(this.$route.query)
      this.index = this.$route.query.index
      this.cpinfo = jsonData[this.index]

      console.log(jsonData)
    },
    methods:{
      onClickLeft(){
        this.$router.push({path:'/cplist'})
      },
      onClickRight(){
        this.tokefu()
      },
      onClickButton(){
        this.tokefu()
      },
      escape2Html(str) {                            //转义字符转换普通字符的方法
           var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
           return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];});
         },
      tokefu(){
        // this.$router.push({path:'https://work.weixin.qq.com/kfid/kfc6aef269f86179f87'})
        window.open('https://work.weixin.qq.com/kfid/kfc6aef269f86179f87')

      }

    }
  }

</script>

<style>

    .van-nav-bar__title{
      color: #fff;
    }
    .van-nav-bar__text{
      color: #fff;
    }
    .van-nav-bar .van-icon{
      color: #fff;
    }


</style>



// WEBPACK FOOTER //
// src/views/cpdetail/index.vue